import React, { useState } from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import { 
  BarChart3, 
  Package, 
  MessageSquare, 
  FileText, 
  Settings,
  Menu,
  LogOut
} from 'lucide-react';
import BurrowLogo from '../BurrowLogo';
import styles from './DashboardLayout.module.css';

import Overview from './Overview';
import MyOrders from './MyOrders';
import CommentsLog from './CommentsLog';
import Reports from './Reports';
import AccountSettings from './AccountSettings';

const NAV_ITEMS = [
  { path: '', label: 'Overview', icon: BarChart3 },
  { path: 'orders', label: 'My Orders', icon: Package },
  { path: 'comments', label: 'Comments Log', icon: MessageSquare },
  { path: 'reports', label: 'Reports', icon: FileText },
  { path: 'settings', label: 'Account Settings', icon: Settings }
];

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate('/');
  };

  const toggleSidebar = () => setSidebarOpen(o => !o);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className={styles.layout}>
      
      {/* Mobile Overlay */}
      <div 
        className={`${styles.overlay} ${sidebarOpen ? styles.overlayOpen : ''}`} 
        onClick={closeSidebar}
      />

      {/* Sidebar */}
      <aside className={`${styles.sidebar} ${sidebarOpen ? styles.sidebarOpen : ''}`}>
        <div className={styles.logoArea}>
          <div className={styles.logo}>
            <BurrowLogo height={26} />
          </div>
        </div>
        
        <nav className={styles.nav}>
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.label}
              to={item.path}
              end={item.path === ''}
              onClick={closeSidebar}
              className={({ isActive }) => `${styles.navLink} ${isActive ? styles.active : ''}`}
            >
              <item.icon size={18} className={styles.navIcon} />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Main Area */}
      <main className={styles.main}>
        {/* Topbar */}
        <header className={styles.topbar}>
          <button className={styles.hamburger} onClick={toggleSidebar}>
            <Menu size={24} />
          </button>
          
          <div className={styles.userMenu}>
            <span className={styles.clientName}>Client Portal</span>
            <div className={styles.avatar}>CP</div>
            <button className={styles.logoutBtn} onClick={handleLogout}>
              <LogOut size={16} />
              Log out
            </button>
          </div>
        </header>

        {/* Content Area Rendering Sub-Routes */}
        <div className={styles.content}>
          <Routes>
            <Route index element={<Overview />} />
            <Route path="orders" element={<MyOrders />} />
            <Route path="comments" element={<CommentsLog />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<AccountSettings />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}
